export default "__VITE_ASSET__Don75NbI__"